import { render, staticRenderFns } from "./backcharges-manage.vue?vue&type=template&id=51023ac9"
import script from "./backcharges-manage.vue?vue&type=script&lang=js"
export * from "./backcharges-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports